import React, { useState } from "react";
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import styles from "../../read-documents/styles/tableResults.module.scss";
import { ITableElement } from "shared/components/interfaces/table.interface";
import { IExportedPackage } from "../types";
import { FooterTable } from "shared/components/table/components/FooterTable";

interface TableExportedPackagesProps {
  columns: ITableElement<IExportedPackage>[];
  data: IExportedPackage[];
  valuesResultsPages: number[];
  page: number;
  size: number;
  totalElements: number;
  contentSize: number;
  onChangePage: (page: number) => void;
  onChangeSize: (size: number) => void;
}

export const TableExportedPackages = ({
  columns,
  data,
  valuesResultsPages,
  page,
  size,
  totalElements,
  contentSize,
  onChangePage,
  onChangeSize,
}: TableExportedPackagesProps) => {
  const [orderBy, setOrderBy] = useState<string | null>(null);
  const [orderDirection, setOrderDirection] = useState<"asc" | "desc">("asc");

  const handleChangePage = (
    _event: React.ChangeEvent<unknown>,
    newPage: number,
  ) => {
    onChangePage(newPage);
  };

  const handleChangeSizePage = (event: any) => {
    onChangeSize(parseInt(event.target.value, 10));
  };

  const handleSortByColumn = (columnSortable: string) => {
    if (orderBy === columnSortable) {
      setOrderDirection(orderDirection === "asc" ? "desc" : "asc");
    } else {
      setOrderBy(columnSortable);
      setOrderDirection("asc");
    }
  };

  const isColumnSorted = (columnSortable: string) => {
    return orderBy === columnSortable;
  };

  const renderSortIcon = (columnSortable: string) => {
    const isSorted = isColumnSorted(columnSortable);

    if (!isSorted) {
      return <KeyboardArrowDownIcon className={styles.sortIcon} />;
    }

    if (orderDirection === "asc") {
      return <KeyboardArrowUpIcon className={styles.sortIcon} />;
    }

    return <KeyboardArrowDownIcon className={styles.sortIcon} />;
  };

  return (
    <React.Fragment>
      {data.length > 0 ? (
        <Paper
          className={styles.containerTableResults}
          style={{ display: "flex", flexDirection: "column", height: "72vh" }}
        >
          <TableContainer className={styles.tableResults} sx={{ maxHeight: "calc(72vh - 60px)" }}>
            <Table
              sx={{ minWidth: 700 }}
              aria-label="exported packages table"
              data-testid="table-exported-packages"
            >
              <TableHead>
                <TableRow className={styles.tablaHeader}>
                  {columns.map((column, index) => (
                    <TableCell
                      key={column.field + "_" + index}
                      align="left"
                      className={styles.tableCell}
                      style={{
                        minWidth: column.minWidth,
                        display: column.isHidden ? "none" : "",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {column.headerName}
                      {column.sortable && (
                        <IconButton
                          onClick={() => handleSortByColumn(column.sortable!)}
                          style={{ padding: "0" }}
                          className={`${styles.sortButton} ${
                            isColumnSorted(column.sortable)
                              ? styles.sortButtonActive
                              : ""
                          }`}
                          data-testid={`sort-button-${column.field}`}
                        >
                          {renderSortIcon(column.sortable)}
                        </IconButton>
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody data-testid="table-exported-packages-body">
                {data.map((row, index) => (
                  <TableRow key={`${row.id}-${index}`}>
                    {columns.map((column, index2) => (
                      <TableCell
                        key={column.field + "_" + index2}
                        align="left"
                        className={`${styles.tableCell} ${
                          column.isReduceCellPadding && styles.padding1
                        }`}
                        style={{
                          display: column.isHidden ? "none" : "",
                        }}
                        data-testid={`table-cell-${column.field}-${row.id}`}
                      >
                        {column.renderCell ? column.renderCell(row) : null}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <FooterTable
            handleChangePage={handleChangePage}
            handleChangeSizePage={handleChangeSizePage}
            numberPage={page}
            size={size}
            sizeRows={size.toString()}
            totalElements={totalElements}
            valuesResultsPages={valuesResultsPages}
            contentSize={contentSize}
          />
        </Paper>
      ) : (
        <Box
          className={styles.containerResults}
          data-testid="message_no_search"
        >
          No se encontraron resultados relacionados a su búsqueda
        </Box>
      )}
    </React.Fragment>
  );
};
